/*
 * The logo of Parta (31.10, his pick of the bold set «у стилі референсу»: variant 6, «PΛRTΛ»): heavy
 * geometric capitals built from plain shapes, the A's without their bars, one colour — the ink on the
 * paper or the paper on the ink. The same outlines draw the site, the app and the presentation.
 * Drawn on a box 0…100 high; a shape with a hole (the bowls of P and R) is filled with `evenodd`.
 */

/** The bold P alone: the mark of an icon (box 96 × 100). */
export const BRAND_P =
  'M0 0 H64 A32 32 0 0 1 96 32 A32 32 0 0 1 64 64 H34 V100 H0 Z M34 26 H56 A6 6 0 0 1 56 38 H34 Z';

const p = (x: number) =>
  `M${x} 0 H${x + 64} A32 32 0 0 1 ${x + 96} 32 A32 32 0 0 1 ${x + 64} 64 H${x + 34} V100 H${x} Z ` +
  `M${x + 34} 26 H${x + 56} A6 6 0 0 1 ${x + 56} 38 H${x + 34} Z`;
const a = (x: number) =>
  `M${x} 100 L${x + 38} 0 H${x + 66} L${x + 104} 100 H${x + 70} L${x + 52} 48 L${x + 34} 100 Z`;
const r = (x: number) => `${p(x)} M${x + 38} 64 H${x + 74} L${x + 100} 100 H${x + 64} Z`;
const t = (x: number) => `M${x} 0 H${x + 96} V32 H${x + 65} V100 H${x + 31} V32 H${x} Z`;

/** The whole word PΛRTΛ (box 518 × 100). */
export const BRAND_WORD = [p(0), a(102), r(212), t(316), a(414)].join(' ');
export const BRAND_WORD_BOX = { width: 518, height: 100 } as const;
export const BRAND_P_BOX = { width: 96, height: 100 } as const;
